import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propFunc, propNumber, propBool, propArrayShape, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { useScrollFixed } from '../../../../../../../helpers/use/useScrollFixed';
import CharmPointRow from '../../CharmPoint/CharmPointRow';
const RfpOneDescriptionFixedRow = (props) => {
    const { charmPoint, charmPoints, driverTargetTwoRef, isActiveDriverTarget, isDisabled, onChangeCompleteInputRange, onChangeInputRange, onClickDriverTarget, } = props;
    const { isFixed, ref } = useScrollFixed.useScrollFixedDetect();
    return (_jsxs("div", Object.assign({ className: clsx('rfp-one-description-fixed-row', {
            'is-fixed': isFixed,
        }), ref: ref }, { children: [_jsx("div", { className: 'rfp-one-description-fixed-row-spacer' }), _jsx("div", Object.assign({ className: 'charmpoint_row' }, { children: _jsx(CharmPointRow, { arrowColor: 'white', charmPoint: charmPoint, charmPoints: charmPoints, driverTargetRef: driverTargetTwoRef, isActiveDriverTarget: isActiveDriverTarget, isDisabled: isDisabled, onChange: onChangeInputRange, onChangeComplete: onChangeCompleteInputRange, onClickDriverTarget: onClickDriverTarget }) }))] })));
};
RfpOneDescriptionFixedRow.propTypes = {
    charmPoint: propNumber().isRequired,
    charmPoints: propArrayShape().isRequired,
    driverTargetTwoRef: propShape(),
    isActiveDriverTarget: propBool(),
    isDisabled: propBool().isRequired,
    onChangeCompleteInputRange: propFunc().isRequired,
    onChangeInputRange: propFunc().isRequired,
    onClickDriverTarget: propFunc(),
};
RfpOneDescriptionFixedRow.defaultProps = {
    driverTargetTwoRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default RfpOneDescriptionFixedRow;
